import { useState } from "react";
import { QUARTERS, showErrorToast } from "../../../../utils";
import { useGetSupplierSpecificReport } from "../../../../hooks/query";
import { YearSelector } from "../../../../components";
import { QuarterSelector } from "../../../../components/QuarterSelector";
import {
  Flex,
  useBreakpointValue,
  useToast
} from "@chakra-ui/react";
import * as React from "react";
import { SupplierSpecificReportCharts } from "./components";

function SupplierSpecificReport({ containerFlow }) {
  const toast = useToast();
  const selectorFlow = useBreakpointValue({
    sm: "row",
    base: "column"
  });

  const [selectedYear, setSelectedYear] = useState((new Date().getFullYear() - 1).toString());
  const [selectedQuarter, setSelectedQuarter] = useState(QUARTERS.ALL);
  const [reportData, setReportData] = useState(null);

  const {
    isFetching
  } = useGetSupplierSpecificReport({
    year: selectedYear,
    quarter: selectedQuarter
  }, {
    onSuccess: (data) => {
      setReportData(data);
    },
    onError: (err) => {
      if (err.response?.status === 404) {
        setReportData(null);
      } else {
        showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message);
      }
    },
    cacheTime: 0
  });

  return (
    <Flex paddingInlineStart={containerFlow === "row" ? 4 : 0} flexFlow="column" gap={4}>
      <Flex gap={selectorFlow === "row" ? 2 : 0} flexFlow={selectorFlow}>
        <YearSelector
          selectedYear={selectedYear}
          handleYearSelection={(value) => setSelectedYear(value)}
          groupStyles={{ marginBlock: 0 }}
        />
        <QuarterSelector
          selectedQuarter={selectedQuarter}
          handleQuarterSelection={(value) => setSelectedQuarter(value)}
          groupStyles={{ marginBlock: 0 }}
        />
      </Flex>
      {!isFetching && <SupplierSpecificReportCharts reportData={reportData} />}
    </Flex>
  );
}

export default SupplierSpecificReport;